import { gql } from "@apollo/client"

export const GET_CITY_BY_STATE = gql`
  query GetCitiesByState($stateId: Int!) {
    getCitiesByState(stateId: $stateId) {
      data {
        id
        name
        email
        phone
      }
    }
  }
`
